import { forwardRef } from 'react';
import { ScrollableBox } from '../../../ScrollableContainers';
import { IAutocompleteProps } from '../../index';

const SCROLLABLE_BOX_SX = { height: '100%' };

type IAutocompleteScrollableListBoxProps = IAutocompleteProps['ListboxProps'] & {};

type TAutocompleteScrollableListBox = ReturnType<
  typeof forwardRef<HTMLDivElement, IAutocompleteScrollableListBoxProps>
>;

const AutocompleteScrollableListBox: TAutocompleteScrollableListBox = forwardRef<
  HTMLDivElement, IAutocompleteScrollableListBoxProps
>((props, ref) => {
  const { children, ...rest } = props;

  /*
    An outer div is needed; otherwise - there will be an error.
    To reproduce:
      remove the outer div
      go to the ServiceSelector stories
      type two letters in the website selector
    An inner div is needed as well; otherwise - there will be an error.
    To reproduce:
      remove the inner div
      go to the Default Autocomplete
      select an option
      click on Autocomplete to open the options list
      press 'X' to remove the selected item
  */
  return (
    <div>
      {/* @ts-ignore TODO: remove ts-ignore */}
      <ScrollableBox sx={SCROLLABLE_BOX_SX} ref={ref} {...rest}>
        <div>{children}</div>
      </ScrollableBox>
    </div>
  );
});

export default AutocompleteScrollableListBox;
